import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { SiteContainer, Flex } from 'core/layout'
import { Menu, Search } from 'core/icons'
import { Logo, Button } from 'elements'
import { ButtonStylerGrey } from 'elements/Button/styled'
import { CookieInfo } from 'modules'
import {
  LanguagesNav,
  Search as SearchBlock,
  FontSizeMenu,
  ThemeModeMenu,
  MobileMenu
} from './components'
import tulkojumi from 'utils/tulkojumi'
import getHomeURL from 'utils/getHomeURL'
import isDescendant from 'utils/isDescendant'
import {
  FixedTop,
  PrintLogo,
  BorderContainer,
  MainWrapper,
  MenuWrapper,
  SearchWrapper,
  StyledHeader,
  LeftGroup,
  RightGroup
} from './styled'

const QUERY = gql`
query HeaderQuery($lang: String!, $useOfCookiesId: [Int], $disagreementToUseOfCookiesId: [Int]) {
  primary: menu(lang: $lang, _id: "primary") {
    items {
      title
      path
      rewrite_url
      rewrite_source
      rewrite_target
    }
  }
  secondary: menu(lang: $lang, _id: "scondary") {
    items {
      title
      path
      rewrite_url
      rewrite_source
      rewrite_target
    }
  }
  searchLapa: page(lang: $lang, _id: 3660) {
    path
  }
  disagreementToUseOfCookiesPage: page(lang: $lang, _id: $disagreementToUseOfCookiesId) {
    path
  }
  useOfCookiesPage: page(lang: $lang, _id: $useOfCookiesId) {
    path
  }
  languages: language {
    name
    path
    _id
  }
  teksti(lang: $lang, _id:[
    "izvelne",
    "liepaja_uz_sakumlapu",
    "meklet_lapas_satura",
    "es_mekleju",
    "rezims_vajredzigajiem",
    "teksta_izmers",
    "aizvert",
    "piekritu",
    "nepiekritu",
    "uzzinat_vairak",
    "sikdatnes_palidz_uzlabot_pakalpojumu_kvalitati",
    "izmantojot_so_lapu_jus_piekritat_sikdatnu_izmantosanai"
  ]) {
    _id
    text
  }
}
`
const useOfCookiesWpId = { ru: 5715, en: 5710, lv: 5707 }
const disagreementToUseOfCookiesWpId = { ru: 18922, en: 18918, lv: 18770 }

const queryOptions = {
  options: ({ activeLang }) => {
    const lang = activeLang || 'lv'
    return {
      fetchPolicy: 'cache-first',
      variables: {
        lang,
        useOfCookiesId: useOfCookiesWpId[lang],
        disagreementToUseOfCookiesId: disagreementToUseOfCookiesWpId[lang]
      }
    }
  },
  props: props => {
    const { data: {
      loading,
      primary,
      secondary,
      searchLapa,
      useOfCookiesPage,
      disagreementToUseOfCookiesPage,
      languages,
      teksti
    } } = props

    return {
      path: props.path,
      data: {
        loading,
        primary,
        secondary,
        searchLapa,
        useOfCookiesPage,
        disagreementToUseOfCookiesPage,
        languages,
        teksti
      }
    }
  }
}

class Header extends React.PureComponent {
  state = {
    searchOpen: false,
    menuOpen: false,
    searchInView: true
  }

  componentDidMount() {
    window.addEventListener('click', this._onWindowClick)

    this._observer = new MutationObserver(mutation => {
      const searchInView = mutation[0].target.classList.contains('search-in-view')
      this.setState(prevState => ({...prevState, searchInView }))
    });

    this._observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  componentDidUpdate(prevProps, prevState) {
    this._updateHeight()
    if (prevProps.forceRender !== this.props.prevProps && prevState.searchOpen) {
      this._onSearchClose()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this._onWindowClick)

    if (this._observer) {
      this._observer.disconnect()
      this._observer = null
    }

    if (this._timeout) {
      window.clearTimeout(this._timeout)
      this._timeout = null
    }
  }

  _updateHeight = () => {
    const contentContainer = document.body.querySelector('[data-query-id="js-content-container"]')
    const header = document.body.querySelector('[data-query-id="js-header"]')
    if (contentContainer && header) {
      const headerRect = header.getBoundingClientRect()
      contentContainer.style.paddingTop = `${headerRect.height}px`
    }
  }

  _onWindowClick = event => {
    /* NOTE: Komponents pages/Meklētājs definē pogu ar atribūtu
    data-query-id='js-search-button', lai nodrošinātu nepieciešamo sasaisti */
    if (event && event.target.getAttribute('data-query-id') === 'js-search-button') {
      this._onSearch()
      event.preventDefault()
      event.stopImmediatePropagation()
    }

    if (!this.state.searchOpen) {
      return
    }

    if (this._catchWindowEvent) {
      this._catchWindowEvent = false
      return
    }
    const inside = isDescendant(this._header, event.target)
    if (!inside) {
      this._onSearchClose()
    }
  }

  _onSearch = () => {
    this._catchWindowEvent = true
    this.setState(prevState => Object.assign({}, prevState, {
      searchOpen: true
    }))

    const html = document.querySelector('html')
    html.classList.add('no-scroll')
    document.body.classList.add('no-scroll')
  }

  _onSearchClose = () => {
    this._catchWindowEvent = false
    this.setState(prevState => Object.assign({}, prevState, {
      searchOpen: false
    }))

    const html = document.querySelector('html')
    html.classList.remove('no-scroll')
    document.body.classList.remove('no-scroll')
  }

  _scrollToSearch = () => {
    const target = document.body.querySelector('div[data-id="search-block"]')
    if (target) {
      let pageOffsetTop = 65
      const containsCookiesInfo = document.body.querySelector(`div[data-query-id="js-cookie-info"]`)
      if (containsCookiesInfo) {
        const { height } = containsCookiesInfo.getBoundingClientRect();
        pageOffsetTop += height;
      }

      window.scrollTo({ top: target.offsetTop - pageOffsetTop, behavior: "smooth" })

      this._timeout = window.setTimeout(() => {
        const input = target.querySelector('input')
        if (input) {
          input.focus()
        }
      }, 500)
    }
  }

  render() {
    const {
      onThemeChange,
      onFontChange,
      activeLang,
      path,
      data: {
        loading,
        primary,
        secondary,
        searchLapa,
        useOfCookiesPage,
        disagreementToUseOfCookiesPage,
        languages,
        teksti
      }
    } = this.props

    if (loading) {
      return null
    }

    const layout = this.props.breakpoint
    const compact = layout !== 'desktop'

    const GreyButton = props => (
      <ButtonStylerGrey>
        <Button {...props}>
          {props.children}
        </Button>
      </ButtonStylerGrey>
    )

    const fontSizeMenu = props => (
      <FontSizeMenu
        key='font-size-menu'
        onChange={onFontChange}
        teksti={teksti}
        {...props} />
    )

    const themeModeMenu = props => (
      <ThemeModeMenu
        key='theme-mode-menu'
        onChange={onThemeChange}
        teksti={teksti}
        {...props} />
    )

    const rightGroupContents = [
      <LanguagesNav
        key='language-nav'
        languages={languages}
        activeLang={activeLang} />
    ]
    if (layout !== 'mobile' && layout !== 'tabletSmall') {
      rightGroupContents.push(
        fontSizeMenu(), themeModeMenu()
      )
    }

    let forceUpdate = false
    if (__isBrowser__) {
      forceUpdate = window && window.location.pathname
    }

    const homeURL = getHomeURL(activeLang)
    let isHome = true;
    if (__isBrowser__) {
      let currentPathname = window && window.location.pathname;
      if (currentPathname.charAt(currentPathname.length - 1) !== "/") {
        currentPathname += "/";
      }
      isHome = currentPathname === homeURL;
    }

    const showToolbarSearch = !this.state.searchInView || !isHome

    return (
      <FixedTop data-query-id='js-header'>

        <CookieInfo
          teksti={teksti}
          onUpdateState={this._updateHeight}
          useOfCookiesPage={useOfCookiesPage && Array.isArray(useOfCookiesPage) && useOfCookiesPage.length > 0 && useOfCookiesPage[0]}
          disagreementToUseOfCookiesPage={disagreementToUseOfCookiesPage && Array.isArray(disagreementToUseOfCookiesPage) && disagreementToUseOfCookiesPage.length > 0 && disagreementToUseOfCookiesPage[0]} />

        <StyledHeader innerRef={c => { this._header = c }}>
          <SiteContainer>

            {/* TODO: <SkipLinks /> */}

            <PrintLogo>
              <Logo large />
            </PrintLogo>

            <Flex>
              <MenuWrapper basis={1 / 12}>
                <GreyButton
                  type='text'
                  icon={Menu}
                  adjustPosition
                  // a11yLabel={tulkojumi(teksti, 'izvelne')}
                  title={tulkojumi(teksti, 'izvelne')}
                  onClick={() => {
                    this.setState(prevState => Object.assign({}, prevState, {
                      menuOpen: true
                    }))
                    const html = document.querySelector('html')
                    html.classList.add('no-scroll')
                    document.body.classList.add('no-scroll')
                  }} />
              </MenuWrapper>

              <MainWrapper basis={(showToolbarSearch ? 9 : 11) / 12}>
                <LeftGroup>
                  <div>
                    <Link to={homeURL} rel='noopener' title={tulkojumi(teksti, 'liepaja_uz_sakumlapu')}>
                      <Logo />
                    </Link>
                  </div>
                </LeftGroup>

                <RightGroup>
                  {rightGroupContents}
                </RightGroup>
              </MainWrapper>

              {showToolbarSearch && (
                <SearchWrapper basis={2 / 12}>
                  <BorderContainer>
                    <GreyButton
                      type='text'
                      reverse
                      icon={Search}
                      iconSize='large'
                      // a11yLabel={tulkojumi(teksti, 'meklet_lapas_satura')}
                      title={tulkojumi(teksti, 'meklet_lapas_satura')}
                      label={compact ? null : tulkojumi(teksti, 'es_mekleju')}
                      onClick={event => {
                        isHome ? this._scrollToSearch() : this._onSearch(event)
                      }} />
                  </BorderContainer>
                </SearchWrapper>
              )}
            </Flex>

          </SiteContainer>

          <SearchBlock
            isOpen={this.state.searchOpen}
            onClose={this._onSearchClose}
            searchLapa={searchLapa && Array.isArray(searchLapa) && searchLapa.length > 0 && searchLapa[0]}
            lang={this.props.activeLang}
            teksti={teksti} />

          <MobileMenu
            path={path}
            homeURL={homeURL}
            primary={primary[0]}
            secondary={secondary[0]}
            teksti={teksti}
            forceUpdate={forceUpdate}
            isOpen={this.state.menuOpen}
            onClose={() => {
              this.setState(prevState => Object.assign({}, prevState, {
                menuOpen: false
              }))
              const html = document.querySelector('html')
              html.classList.remove('no-scroll')
              document.body.classList.remove('no-scroll')
            }}
            fontSizeMenu={fontSizeMenu({ inline: true })}
            themeModeMenu={themeModeMenu({ inline: true })} />

        </StyledHeader>
      </FixedTop>
    )
  }
}

const mapStateToProps = ({ breakpoint }) => ({
  breakpoint
})

export default compose(
  graphql(QUERY, queryOptions),
  connect(mapStateToProps)
)(Header)



// WEBPACK FOOTER //
// ./src/modules/Header/Header.jsx